module.exports = __webpack_public_path__ + "img/视频部.9d5cce29.jpg";